import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
import { If } from "@componentsShared/Conditional/If";
var RadioCardExpandable = function RadioCardExpandable(_ref) {
  var name = _ref.name,
    value = _ref.value,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    children = _ref.children,
    title = _ref.title,
    description = _ref.description,
    sideNote = _ref.sideNote,
    className = _ref.className,
    radioMarkClassName = _ref.radioMarkClassName,
    radioCircleClassName = _ref.radioCircleClassName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge("px-4 py-3 bg-white rounded-lg border border-solid border-gray-gainsboro md:p-6", checked && "border border-solid border-primary-old", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "flex items-center gap-4 cursor-pointer justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled,
    className: "opacity-0 hidden"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-6 h-6 border border-solid border-[#e4ebf4] rounded-full flex-grow-0 flex-shrink-0", checked ? "border-2 border-primary-old flex items-center justify-center" : "bg-white", radioMarkClassName)
  }, /*#__PURE__*/React.createElement(If, {
    condition: checked
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-3 h-3 bg-primary-old rounded-full", radioCircleClassName)
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-start text-gray-text text-base font-bold leading-normal"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "text-start text-gray-causeway text-sm font-semibold"
  }, description))), /*#__PURE__*/React.createElement(If, {
    condition: !!sideNote
  }, sideNote)), children)));
};
export default RadioCardExpandable;